import React from 'react';
import getIncrementKeys from './incrementKeysMappings';
import { getCurrencyIso } from '~shared/utils/user';
import KeyboardButton from './KeyboardButton';
import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

const IncrementKeys = () => {
    const { incrementBy } = useKeyboard();
    const keys = getIncrementKeys(getCurrencyIso());

    return (
        <ul className="fullslip__increment-keys">
            {
                keys.map((keyText) => <li
                    className="fullslip__increment-key"
                    key={keyText}
                >
                    <KeyboardButton
                        keyText={`+${keyText}`}
                        clickHandler={() => incrementBy(keyText)}
                        dataTestId={`betslip-keyboard;incr${keyText}`}
                        gtmAttribute={`new-betslip;stake-area;quickstake-${keyText}`}
                    />
                </li>)
            }
        </ul>
    );
};

export default IncrementKeys;
